import type { Resource } from '../../';
export const country_countries_GR: Resource = {"default":"Greece"};
